module.exports = __webpack_public_path__ + "static/media/IB_core_cas.e60e930c.png";